import React from 'react';
import consultantsEndpoint from 'endPoints/consultants';
import PageLayout from './components/PageLayout';
import Filters from 'pages/Consultants/components/Filters';
import CardTemplate from 'pages/Consultants/components/CardTemplate';
import ListImage from 'assets/images/illustration-consultant.png';
import ChosenFilters from './components/ChosenFilters';

const Consultants = () => {
  const breadcrumbs = React.useMemo(
    () => [
      { label: 'Home', link: '/' },
      { label: 'consultants' }
    ],
    []
  );

  return (
    <PageLayout
      endPoint={consultantsEndpoint}
      translate={'Consultants'}
      breadcrumbs={breadcrumbs}
      innerPage={'consultants'}
      Filters={Filters}
      CardTemplate={CardTemplate}
      ChosenFilters={ChosenFilters}
      loading={false}
      ListImage={ListImage}
    />
  );
};

export default Consultants;
